import { TextField } from "@mui/material";
import { useState, useEffect } from "react";

import Svg from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export default function SearchBar({ searchText, setSearchText }) {
  const [localSearch, setLocalSearch] = useState(searchText);

  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchText(localSearch);
    }, 700);

    return () => {
      clearTimeout(handler);
    };
  }, [localSearch, setSearchText]);

  return (
    <div
      className="inline-flex w-full flex-row content-center items-center rounded-[500px] border-[1px]"
      style={{ borderColor: HNSColors.secondary[800] }}
    >
      <div className="ml-4 mr-0">
        <Svg name="his-magnifying-glass" color={HNSColors.neutrals[600]} sx={{ height: "20px" }} />
      </div>
      <div className="flex-1">
        <TextField
          id="search-bar"
          label="Search Notes"
          className="w-full"
          variant="outlined"
          value={localSearch}
          onChange={(e) => setLocalSearch(e.target.value)}
          slotProps={{ inputLabel: { shrink: true } }}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": { border: "none" },
              "&:hover fieldset": { border: "none" },
              "&.Mui-focused fieldset": { border: "none" },
            },
            "& .MuiInputLabel-shrink": { display: "none" },
            "& .MuiInputBase-input": { padding: "10px 12px", fontSize: "14px" },
            "& .MuiFormLabel-root": {
              fontSize: "14px",
              position: "absolute",
              top: "-5px",
            },
          }}
        />
      </div>
    </div>
  );
}
